import {TFunction} from 'i18next'

/**
 * React-hooks-forms validator for use in a `register` call.  Preconfigured for `min` value validation
 */
export const minValidator = (t: TFunction, value: number) => ({
  min: {
    value,
    message: t('error.minValue', {value})
  }
})

/**
 * React-hooks-forms validator for use in a `register` call.  Preconfigured for `max` value validation
 */
export const maxValidator = (t: TFunction, value: number) => ({
  max: {
    value,
    message: t('error.maxValue', {value})
  }
})

/**
 * React-hooks-forms validator for use in a `register` call.  Preconfigured for `maxLength` string-length validation
 */
export const maxLengthValidator = (t: TFunction, value: number) => ({
  maxLength: {
    value,
    message: t('error.maxLength', {value})
  }
})

export const rangeValidator = (t: TFunction, [min, max]: [number, number]) => ({
  ...minValidator(t, min),
  ...maxValidator(t, max)
})

export const requiredValidator = (t: TFunction) => ({
  required: t('error.required')
})
